import axios from "axios";
import { newApiBaseUrl } from "../../axiosInstance";

export const checkout = (data, branch) => {
  console.log("checkout data:", data);
  return axios.post(
    `${newApiBaseUrl}/carts/me/checkout?branch=${branch}`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};

export const orderGet = (data) => {
  return axios.get(
    `${newApiBaseUrl}/admin/orders?fromDate=${data.from}&toDate=${data.to}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};
export const orderPerCustomer = (customerId, branch) => {
  return axios.get(`${newApiBaseUrl}/orders?branch=${branch}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const updateOrderStatus = (orderId, status, branch) => {
  return axios.put(
    `${newApiBaseUrl}/orders/${orderId}`,
    { branch, status },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};
